import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiDocuments } from 'modules/api';
import { DocumentCategory } from 'modules/types/Document';
import { PagingParams } from 'modules/types/PagingParams';

export const fetchDocuments = createAsyncThunk(
  'documentation/fetchDocuments',
  async (
    params: PagingParams & { documentCategory?: DocumentCategory },
    { rejectWithValue },
  ) => {
    try {
      const response = await ApiDocuments.getDocuments(params);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const uploadDocuments = createAsyncThunk(
  'documentation/uploadDocuments',
  async (
    params: { formData: FormData; documentCategory: DocumentCategory },
    { rejectWithValue },
  ) => {
    try {
      const response = await ApiDocuments.uploadDocuments({
        formData: params.formData,
        documentCategory: params.documentCategory,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchDocumentTypes = createAsyncThunk(
  'documentation/fetchDocumentTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiDocuments.getDocumentTypeCodes();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
